export default class Helpers {
  static generateRandomId(length = 12) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    const charactersLength = characters.length;
    let counter = 0;

    while (counter < length) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
    }

    return result;
  }

  static isElementInViewport = (element, partiallyVisible = false) => {
    const { top, left, bottom, right } = element.getBoundingClientRect();
    const { innerHeight, innerWidth } = window;
    return partiallyVisible
      ? ((top > 0 && top < innerHeight) ||
          (bottom > 0 && bottom < innerHeight)) &&
          ((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
      : top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
  };

  static once(key, { storage = 'local', prefix = 'aui-once' } = {}) {
    const storageKey = `${prefix}:${key}`;
    const store = storage === 'session' ? sessionStorage : localStorage;

    if (store.getItem(storageKey)) {
      return false;
    }

    return {
      commit: () => store.setItem(storageKey, '1'),
      key: storageKey
    };
  }
};

